import { render, staticRenderFns } from "./AiBroadcastForm.vue?vue&type=template&id=594ab6f8&scoped=true&"
import script from "./AiBroadcastForm.vue?vue&type=script&lang=js&"
export * from "./AiBroadcastForm.vue?vue&type=script&lang=js&"
import style0 from "./AiBroadcastForm.vue?vue&type=style&index=0&id=594ab6f8&lang=scss&scoped=true&"
import style1 from "./AiBroadcastForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594ab6f8",
  null
  
)

export default component.exports